import httpManager from '../../util/common'
import TitleLabel from '../components/TitleLabel'
import newsTypeLists from '../../../static/json/news_labels.json'
import { timestampToDate, dealNewsTypeLists } from '../../util/util'
import Cookies from 'js-cookie'

export default {
  components: {TitleLabel},
  props: ['oaid'],
  data () {
    return {
      loading: false,
      newsList: [],
      page: {
        pagenum: 1,
        pagesize: 5,
        total: 0,
        pagerCount:3,
        perfect: true,
      }
    }
  },
  computed: {
    locale () {
      return Cookies.get('locale') || 'zh'
    }
  },
  watch: {
    oaid () {
      this.getData()
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      this.newsList = []
      this.page.total = 0
      let params = new Map()
      let str = dealNewsTypeLists('A')
      params.set('news_type', str)
      params.set('oaid', this.$props.oaid)
      params.set('pagenum', this.page.pagenum)
      params.set('pagesize', this.page.pagesize)
      httpManager('esg_news', params)
        .then(res => {
          const { data } = res.data
          if (Object.prototype.toString.call(data).substring(8, 14) === 'Object') {
            this.page.total = res.data.page.total
            this.loading = false
            return
          }
          data.forEach(item  => {
            item.time = timestampToDate(item.ctime, true)
            if (item.company_info) {
              item.company = ''
              item.company_info.forEach((ele, index) => {
                if (index !== item.company_info.length - 1) {
                  item.company += `${ele.full_name[0]}, `
                } else {
                  item.company += ele.full_name[0]
                }
              });
            }
            newsTypeLists[this.locale].forEach(el => {
              if (el.children) {
                el.children.forEach(val => {
                  if (val.value == item.class) {
                    item.color = el.color
                    item.tag = val.title
                  }
                })
              }
            });
          })
          this.newsList = data
          this.page.total = res.data.page.total
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    cardClick (val) {
      const { href } = this.$router.resolve({
        name: 'newsDetail',
        query: {
          news_id: val
        }
      })
      window.open(href, '_blank')
    },
    onChange ({ currentPage }) {
      this.page.pagenum = currentPage
      this.getData()
    }
  }
}




// WEBPACK FOOTER //
// ./src/entity/js/entity_basic_info.js